const getBalance = () => {
  return new Promise((resolve) => {
    const checkBalance = setInterval(() => {
      const balance = window.Shopwaive?.balance;

      if (balance >= 0) {
        clearInterval(checkBalance);
        resolve(balance);
      }
    }, 500); 
  });
};

export const fetchBalance = async () => {
  const balance = await getBalance();
  return balance;
};